import VeeValidate from 'vee-validate';

const dictionary = {
  en: {
    messages: {
      required: (fieldName) => `${fieldName} is required.`,
      email: (fieldName) => `${fieldName} must be a valid email.`,
      empty: (fieldName) => `${fieldName} cannot be empty.`,
      min_value: (fieldName, minValue) => `${fieldName} must be at least ${minValue}.`,
      max: (fieldName, maxValue) => `${fieldName} cannot exceed ${maxValue} characters.`,
      alpha_num: (fieldName) => `${fieldName} can only contain letters and numbers.`,
    },
  },
};

// Override and merge the dictionaries
VeeValidate.Validator.localize(dictionary);

export default VeeValidate;
